import { PATH_FALLBACK } from "@/services/PathRewriteService";
import { removeRedundantSlashFromPath } from "@/utils/url/removeRedundantSlashFromPath";

const regExp = new RegExp(`/${PATH_FALLBACK}/`, "g");

export function removePathFallbackFromURL(url: string) {
  return removeRedundantSlashFromPath(
    // It requires double replace
    url.replace(regExp, "/").replace(regExp, "/"),
  );
}
